export default {
  message: {
    "error": "Упс! Что-то пошло не так.",
    "Sorrysomeerrorsoccurred": "Произошла непредвиденная ошибка. Вы можете попробовать сменить язык или выйти и перезапустить приложение.",
    "quit": "Выйти",
    "language": "Язык",
    "Youcanchangethelanguagehere": "Вы можете изменить язык здесь!",
    "current": "Текущий",
    "home": "Главная",
    "friends": "Друзья",
    "wallet": "Кошелек",
    "aboutus": "О нас",
    "Sharewithfriends": "Поделиться с друзьями",
    "copyFailure": "Ошибка копирования",
    "copySuccess": "Копирование успешно",
    "Claimreward": "Получить награду",
    "DailyLogin": "Ежедневный вход",
    "noInvitationsYet": "Пока нет приглашений",
    "LoadMore": "Загрузить больше",
    "WatchAD": "Смотреть рекламу",
    "continue": "Продолжить",
    "Congratulations": "Поздравляем",
    "MyFriends": "Мои друзья",
    "Invitefriends": "Пригласить друзей",
    "Invitepremiumfriends": "Пригласить премиум-друзей",
    "DailyTasks": "Ежедневные задания",
    "inviteDesc": "+{num} ${name} за каждого приглашенного друга",
    "DailyTasksDesc": "Выполните задачи, чтобы получить больше airdrop",
    "SponsorsandPartners": "Спонсоры и партнеры",
    "Receivingwallet": "Кошелек для получения",
    "Enterwalletaddress": "Введите адрес кошелька {name}",
    "Claim": "Получить",
    "Booster": "Ускоритель",
    "RentPeriod": "Период аренды",
    "days30": "30 дней",
    "Dailyprofit": "Ежедневная прибыль",
    "Totalprofit": "Совокупная прибыль",
    "Quantity": "Количество",
    "RentPrice": "Цена аренды",
    "RentMiner": "Аренда майнера",
    "Insufficient": "Недостаточно пригласительных",
    "InsufficientMsg": "Вам нужно пригласить {num} друзей, чтобы заработать больше аксессуаров.",
    "Settings": "Настройки",
    "copyid": "Копировать ID",
    "UpgradeSuccessfully": "Успешное обновление",
    "Name": "Имя",
    "userinfo": "Информация о пользователе",
    "disconnect": "Отключиться",
    "Startmining": "Начать майнинг",
    "Welcome": "Добро пожаловать в {name}",
    "Withdrawal": "Вывод",
    "Minimumamount": "Минимальная сумма",
    "Networkfee": "Комиссия сети",
    "Enteramount": "Введите сумму",
    "Submit": "Отправить",
    "MinimumTip": "Сумма вывода слишком мала. Минимальная сумма вывода: {num}",
    "MaximumTip": "Недостаточная сумма, максимальная сумма, которую вы можете вывести: {num}",
    "SubmittedTip": "Отправлено, ожидайте обработки в течение 30-60 рабочих дней",
    "WithdrawStatus": "Статус",
    "Submissiontime": "Время отправки",
    "WithdrawAwaitTip": "* Ожидаемое время обработки составляет 30-60 рабочих дней. Приглашение большего количества друзей может ускорить процесс проверки.",
    "Processing": "Обработка",
    "Amount": "Сумма",
    "Numberoffriends": "Количество друзей: {now}/{limit}",
    "InviteTip": "Чтобы сделать ваш первый вывод, вам нужно пригласить {limit} друзей присоединиться к приложению для майнинга.",
    "openonphone": "Откройте эту ссылку на своем телефоне.",
    "claimTip": "Сумма для получения слишком мала. Минимальная сумма для получения: {num}",
    "WalletBalance": "Баланс кошелька",
    "Withdraw": "Вывод",
    "SetWalletAddress": "Установить адрес кошелька",
    "WithdrawalRecord": "Запись о выводе",
    "Norecords": "Нет записей",
    "Whatis": "Что такое {name}?",
    "All": "Все",
    "save": "Сохранить",
    "successWithdrawal": "Сканирование успешно {num}",
    "secondsago": "{time} секунд назад",
    "Loading": "Загрузка...",
    "PaymentConfirming": "Проверка статуса транзакции...",
    "Check": "Проверить",
    "CheckFail": "Транзакция не завершена. Пожалуйста, проверьте снова через 5 секунд.",
    "Addname": "Добавьте '{name}' к своему имени",
    "Restattcheck": "Перезапустите приложение, чтобы проверить",
    "Copyname": "Скопировать '{name}'",
    "SubmissionFailed": "Ошибка отправки, пожалуйста, попробуйте позже",
    "WithdrawalReview": "Проверка вывода",
    "WebWithdrawAwaitTip": "* Ожидаемое время обработки составляет 24-48 часов. Приглашение большего количества друзей может ускорить процесс проверки.",
    "Success": "Успех",
    "Rejection": "Отказ",
    "WebSubmittedTip": "Отправлено, мы обработаем это как можно скорее.",
    "select_payment_method": "Выбрать способ оплаты",
    "total_amount": "Общая сумма",
    "next_step": "Следующий шаг",
    "creating_order": "Создание заказа...",
    "order_created": "Заказ создан",
    "order_status": "Статус заказа",
    "order_id": "Идентификатор заказа",
    "order_amount": "Сумма заказа",
    "order_status_desc": "Описание статуса заказа",
    "payment_cancelled": "Оплата отменена",
    "opening_payment": "Открытие оплаты...",
    "payment_success": "Оплата успешна",
    "payment_failed": "Платеж не выполнен",
    "payment_pending": "Платеж в ожидании",
    "payment_processing": "Платеж обрабатывается",
    "create_order_failed": "Не удалось создать заказ",
    "creating_ton_order": "Создание заказа TON...",
    "check_payment_status": "Проверка статуса платежа...",
    "use_ton_payment": "Использовать платеж TON",
    "connect_wallet": "Подключить кошелек",
    "start_transaction": "Начать транзакцию",
    "address": "Адрес",
    "amount_ton": "Сумма TON",
    "copy": "Копировать",
    "comment_memo": "Комментарий",
    "comment_memo_desc": "Пожалуйста, введите комментарий",
    "comment_memo_placeholder": "Введите комментарий",
    "amount": "Сумма",
    "wallet_address": "Адрес кошелька",
    "you_can_choose_to_connect_wallet_to_pay": "Вы можете выбрать подключение кошелька для оплаты",
    "or_manually_transfer_to_the_above_address": "Или вручную перевести на указанный выше адрес (обратите внимание, что сумма и комментарий должны быть точно такими же)",
    "transaction_success": "Транзакция успешна",
    "transaction_failed": "Транзакция не удалась",
    "transaction_error": "Ошибка транзакции",
    "transaction_status": "Статус транзакции",
    "transaction_id": "Идентификатор транзакции",
    "transaction_amount": "Сумма транзакции",
    "transaction_status_desc": "Описание статуса транзакции",
    "miner_detail": "Детали майнера",
    "rent_period": "Период аренды",
    "days": "{days} дней",
    "daily_yield": "Ежедневный доход",
    "total_yield": "Общий доход",
    "invite_friends": "Пригласить друзей",
    "price": "Цена",
    "rent": "Аренда",
    "free_claim": "Бесплатный приз",
    "redeem": "Выкупить",
    "buy": "Аренда",
    "invite_friends_not_enough": "Недостаточно приглашений друзей",
    "redeem_success": "Выкуп успешно",
    "redeem_failed": "Ошибка выкупа",
    "rent_success": "Аренда успешна",
    "rent_failed": "Ошибка аренды",
    "TotalPower": "Общая мощность",
    "MaxQuantity": "Достигнуто максимальное значение",
    "Running": "В процессе",
    "Stop": "Остановить",
    "Withdrawalunlock": "Разблокировка вывода",
    "Close": "Закрыть",
    "Delivering": "Доставка",
    "Duetothelargenumber": "Из-за большого количества получателей, ваш аирдроп ожидается в течение 15-20 рабочих дней",
    "WithdrawalunlockTip": "Вам нужно {num} приглашенных друзей, чтобы завершить задачи/привязать кошельки для разблокировки вывода",
    "mining_title": "Робот",
    "Upgrade": "Обновить",
    "partner": "Партнер",
    "faq": "Часто задаваемые вопросы",
    "task": "Задача",
    "OpenRobot": "Открыть Робота",
    "MyRobot": "Мой Робот",
    "Level": "Уровень",
    "Commission": "Комиссия",
    "DirectFriends": "Прямые друзья",
    "Feedback": "Обратная связь",
    "Pleaseenteryouremailaddress": "Пожалуйста, введите ваш адрес электронной почты",
    "Inputfeedbackcontent": "Введите содержание отзыва",
    "Submitfeedback": "Отправить отзыв",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Отзыв успешно отправлен, спасибо за вашу ценную обратную связь",
    "Feedbacksubmissionfailed,pleaseretriy": "Не удалось отправить отзыв, пожалуйста, попробуйте снова",
    "Addressformaterror": "Ошибка формата адреса",
    "Readclipboardfailed": "Не удалось прочитать буфер обмена",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Вы уже оставляли отзыв сегодня, пожалуйста, вернитесь завтра",
    "Record": "Запись",
    "Newuserguidance": "Просмотреть приветственный тур",
    "Usetonwallet": "Используйте кошелек TON",
    "Reward": "Награда",
    "Connectwallet": "Подключить кошелек",
    "Notconnected": "Не подключен",
    "Disconnect": "Отключить",
    "AboutTAI": "Детали токена",
    "WithdrawalRecordDesc": "Запись о выводе",
    "StartAItrading": "Начать торговлю с AI",
    "Next": "Далее",
    "Start": "Начать",
    "WithdrawalSuccess": "Вывод успешен",
    "WithdrawalFail": "Неудача при выводе",
    "Max": "Макс",
    "WithdrawalRecords": "Записи о выводах",
    "Commissionrules": "Правила комиссии",
    "Mycommission": "Моя комиссия",
    "Shop": "Магазин",
    "BuyDifferentAIrobots": "Обновите с помощью вычислительных устройств для более быстрых сканирований!",
    "CurrentRunningAIrobots": "Текущие работающие ИИ-роботы",
    "DailyProfit": "Ежедневная прибыль",
    "Buy": "Купить",
    "ValidityPeriod": "Срок действия",
    "Days": "Дни",
    "Price": "Цена",
    "APY": "APY",
    "NoRobot": "Нет вычислительной мощности",
    "RemainingTime": "Оставшееся время",
    "InviteandEarn": "Пригласите и зарабатывайте",
    "InvitDec": "Пригласите своих друзей присоединиться к ИИ-торговле и зарабатывать комиссии USDT и токены airdrop вместе!",
    "ShareToGroups": "Поделиться в группах",
    "Select_payment_method": "Выберите способ оплаты",
    "twa_pay_tip_with_memo": "Пожалуйста, убедитесь, что адрес, сумма и мемо соответствуют для перевода.",
    "twa_pay_tip": "Пожалуйста, убедитесь, что адрес и сумма корректны для перевода.",
    "twa_pay_tip_placeholder": "Введите комментарий",
    "twa_pay_tip_placeholder_with_memo": "Введите комментарий с заметкой",
    "twa_pay_tip_placeholder_without_memo": "Введите комментарий без заметки",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Введите комментарий с заметкой",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Введите комментарий без заметки",
    "realtime_ai": "Торговля ИИ в реальном времени",
    "check_transaction_status": "Проверить статус транзакции",
    "transaction_wait": "Транзакция обрабатывается. Вы можете выйти из приложения. Сообщение уведомит вас, когда она будет завершена.",
    "Pleaseenteravalidemailaddress": "Пожалуйста, введите действительный адрес электронной почты",
    "max_robot_tip": "Достигнут лимит покупки — попробуйте другой план для продолжения торговли!",
    "connectFailure": "Не удалось подключить кошелек",
    "connectSuccess": "Успешно подключен кошелек",
    "PayNow": "Оплатить сейчас",
    "min_withdrawal_amount": "Минимальная сумма вывода составляет {num} {coin_name}",
    "max_withdrawal_amount": "Максимальная сумма вывода составляет {num} {coin_name}",
    "balance_not_enough": "У вас недостаточно средств для этого вывода.",
    "Numberofgroups": "Количество групп: {now}/{limit}",
    "Withdraw_success": "Вывод средств успешен",
    "allProfit": "Общая прибыль",
    "AnnualProfit": "Годовая прибыль",
    "ScanWallet": "Сканировать кошелек",
    "wallet_check": "проверка_кошелька",
    "Found": "Найдено",
    "ScanSpeed": "Скорость сканирования",
    "MyComputingPower": "Вычисление",
    "Scanning": "Сканирование!",
    "WithdrawDetail": "Детали вывода",
    "ScanSuccess": "Ваш процент успешных сканирований увеличился!",
    "TaskDescription": "Завершайте задачи, чтобы увеличить вероятность успешного сканирования!",
    "InitializingMiningSystem": "Инициализация системы сканирования...",
    "NoWithdrawalRecord": "Нет записи о выводе",
    "Invite": "Требуемые приглашения",
    "Free": "Бесплатно",
    "Confirm": "Подтвердить",
    "RefreshTasks": "Обновить задачи",
    "NumberofGroups": "Количество групп: {now}/{limit}",
    "SendMessage": "Отправить сообщение",
    "NumberofShares": "Количество акций: {now}/{limit}",
    "NumberofTasks": "Количество заданий: {now}/{limit}",
    "CompleteTask": "Выполнить задание",
    "Accelerated": "Ускоренные",
    "Accelerated_withdrawals_success": "Успешно ускоренные выводы",
    "GoBuy": "Иди купи",
    "SpeedUpScan": "Ускорить",
    "Earnings": "Заработок",
    "learnMore": "Узнать больше",
    "claimSuccess": "Награда успешно получена",
    "claimFailed": "Не удалось получить награду, пожалуйста, попробуйте снова",
    "noDividends": "Нет дивидендов для получения",
    "dividendsInfoFallback": "Пригласите друзей, чтобы заработать рефералские награды"
}};